// generated from 8_871 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const productPurchasedFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("product_purchased_filter"),
  // undefined: 8_800 (99.20%), defined 71 (0.80%)
  blocklisted: z.literal(true).optional(),
  comparison_key: z.enum([
    "3", // 5_051 (56.94%)
    "1", // 3_665 (41.31%)
    "5", // 155 (1.75%)
  ]),
  display_name: z.string(),
  // undefined: 2_735 (30.83%), defined 6_136 (69.17%)
  raw_value: z.int().min(0).optional(),
  // avg: 0.54, min: 0, max: 500
  value: z.int().min(0),
  varies_by_app_group: z.literal(true),
});
